import styles from './PageLoader.module.css';

function PageLoader() {
  return (
    <div className={styles.container}>
      <div className={styles.spinner}></div>
      <p>Loading...</p>
    </div>
  );
}

export default PageLoader;
